import type { FaireProductEntity } from "../../entity_types/product";

export const p_vse2q5rhd3: FaireProductEntity = {
  token: "p_vse2q5rhd3",
  type: "product",
  name: "Carved Crystal Snakes Spirit Animal Gemstone Crystal Carving",
  brandToken: "b_de8f5way8k",
  brandName: "Rock Paradise",
  imageUrl:
    "https://cdn.faire.com/fastly/1fb30b0de6dd8e932643c28e9209b8aa7ffc588fe9592073ddbd6a6516b532f3.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/046f057d744e7f8a76ac5c3ad9ccc875efb398410db9a5446f6102e1778a3b3c.jpeg",
    "https://cdn.faire.com/fastly/73939df6ef97fd116eb88712da9870658e0d5f8600cfcdbe05b00bf112fd840a.jpeg",
    "https://cdn.faire.com/fastly/b684ec30dcc864b2422765e5dbd44f674f2bd3d7bb16e03fea893a7a6d3bc7f7.jpeg",
    "https://cdn.faire.com/fastly/59796caebc86ed7ec690d4643ecff6e91626b800feb659d325c89c821fc76c55.jpeg",
    "https://cdn.faire.com/fastly/e4665f7a56b4d10b6cfa12c883eb33f58dd0c9dff28a08d71d9ca3a12ea1d7c9.jpeg",
    "https://cdn.faire.com/fastly/b8805c18d099a23bfd1927edae88d457054d70ee8ec01987ca262df14d0c1c63.jpeg",
  ],
  priceDollars: 9.01,
  description:
    "Listing is for ONE (1) Carved Crystal Snakes Spirit Animal Gemstone \n\nSnakes carved out of gemstones! These are carved out one by one making each snake special and unique. You choose your desired stone finish. These are perfect for table top decor and garden decor. Add one to your personal collection or gift one to someone special you may know!\n\nSTOCK PHOTO. Measurements, characteristics, and colors may vary. Each one is carved out by hand.\n\nMeasures Approx.: 28mm x 50mm and 32mm tall 32mm- 55mm and 37mm tall\n\nYou Choose your stone! Available in:\n\n * Rose Quartz - Love Stone \n * Crystal Quartz - Power Stone \n * Black Obsidian - Protection Stone \n * Opalite - Uplifting Stone \n * White Howlite - Attunement Stone \n * Red Jasper - Supreme Nurturer \n * Unakite - Stone of Vision \n * Blue Goldstone - Brings Goodluck \n * Larvikite - Grounding Stone\n\n\n***Information provided is folklore and not intended as medical advice or a promise of any outcome.\nCrystal Carving Stocking Stuffer",
  tags: [],
  msrpDollars: 18.01,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-27T00:07:59.313Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
